import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { wideFormInput } from '@services/layout'
import TextInput from '@components/Form/TextInput'
import MessageModal from '@components/Modals/MessageModal'
import urlUtils from '@services/urlUtils'
import {
    PageHeader,
    SubmitBtn,
    SubmitBtnContainer,
    FormWrapper,
    FormRow,
    ErrorText,
    WrapperDiv,
} from '@appearance/styled'
import api from '../services/api'

export default () => {
    const history = useHistory()
    const queryParams = urlUtils.getQueryParams()
    const email = queryParams.email || null
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [passwordValid, setPasswordValid] = useState(null)
    const [confirmPasswordValid, setConfirmPasswordValid] = useState(null)
    const [error, setError] = useState(null)
    const [showDoneModal, setShowDoneModal] = useState(false)

    useEffect(() => {
        setError(null)
        setErrorPerField(confirmPasswordValid, 'סיסמה מחדש לא תקינה')
        setErrorPerField(passwordValid, 'סיסמה לא תקינה')
    }, [confirmPasswordValid, passwordValid])

    const setErrorPerField = (field, error) => {
        if (field === false) {
            setError(error)
        }
    }

    const formValid = () => confirmPasswordValid && passwordValid

    const doSubmit = () => {
        if (formValid()) {
            api.resetPassword(email, password).subscribe(
                (res) => {
                    // console.log('resetPassword res', res)
                    setShowDoneModal(true)
                },
                (error) => console.log('resetPassword error', error)
            )
        }
    }

    if (!email) {
        return null
    }

    return (
        <WrapperDiv>
            <PageHeader>איפוס סיסמה</PageHeader>
            <FormWrapper>
                <FormRow>
                    <ErrorText>{error}</ErrorText>
                </FormRow>
                <FormRow justifyContent={'center'} alignItems={'center'}>
                    <TextInput
                        type="password"
                        label={'סיסמה'}
                        text={password}
                        onChangeText={setPassword}
                        onDoneEdit={setPasswordValid}
                        required={true}
                        width={wideFormInput}
                        isCreatePassword
                        hideRequiredSign
                    />
                </FormRow>
                <FormRow justifyContent={'center'} alignItems={'center'}>
                    <TextInput
                        type="password"
                        label={'סיסמה מחדש'}
                        text={confirmPassword}
                        comparisonText={password}
                        onChangeText={setConfirmPassword}
                        onDoneEdit={setConfirmPasswordValid}
                        required={true}
                        width={wideFormInput}
                        isCreatePassword
                        hideRequiredSign
                    />
                </FormRow>
                <SubmitBtnContainer>
                    <SubmitBtn onClick={doSubmit} disabled={!formValid()}>
                        אפס סיסמה
                    </SubmitBtn>
                </SubmitBtnContainer>
            </FormWrapper>
            <MessageModal
                isOpen={showDoneModal}
                title={'כמעט סיימנו..'}
                mainText={
                    'אנא כנס לאימייל שנשלח אליך כעת ואשר את שינוי הסיסמה לסיום התהליך'
                }
                onClose={() => setShowDoneModal(false)}
            />
        </WrapperDiv>
    )
}
